import { render, staticRenderFns } from "./CasesSectorChart.vue?vue&type=template&id=b6880e7a&scoped=true"
import script from "./CasesSectorChart.vue?vue&type=script&lang=js"
export * from "./CasesSectorChart.vue?vue&type=script&lang=js"
import style0 from "./CasesSectorChart.vue?vue&type=style&index=0&id=b6880e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6880e7a",
  null
  
)

export default component.exports